import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Segment, Header, Button, Message} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import CounterInput from "react-counter-input";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// import { Segment, Tab } from 'semantic-ui-react'
import qs from 'query-string';
import _ from 'underscore';
import moment from 'moment';
import ProductView from '../../component/marketplace/product_view';
import {productsBuyAction} from '../../actions/productsActions'
import {getCustomerAction, getEphemeralKeyAction} from '../../actions/stripeActions';

import {
    getMHCYoutubeVideosDetail,
} from '../../actions';

class ProductViewPage extends Component {
    state = {
        type: null,
        id: null,
    }
    componentWillMount() {
        this.reload();
    }

    componentDidUpdate(prevProps) {
        const { contactNoVerified } = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified) {
            this.reload();
        }
    }

    reload() {
        this.checkStripeSession((success) => {
            if (success) {
                this.loadStripeCustomer()
            }
        })
    }

    componentDidMount() {
        // this.props.getMHCArticlesFullList();
        // this.props.getMHCYoutubeVideosFullList();
        const { search } = this.props.location;
        const parsedQueryString = qs.parse(search);
        const {
            id, type
        } = parsedQueryString;
        console.log( id, "SEARCH")
        this.setState({id, type});
        this.setState({quantity: 1})
    }
    render() {
        console.log(this.props.products)
        console.log(this.state.id)
            const selectedProduct = _.find(this.props.products.products, (product) => product.uuid === this.state.id);
            if(selectedProduct){
            return (
                // <div></div>
                    <div>
                    <Header as='h2' attached='top' block>
                        View product
                    </Header>
                    <Link to="/app/store">
                        <Button attached>
                            Go back to store
                        </Button>
                    </Link>
                    <Segment attached>
                        <iframe 
                            src={selectedProduct.url} 
                            width="100%"
                            height="850"
                            frameBorder="0"
                        />
                    </Segment>
                    <div>
                        { this.props.stripe.error &&
                            <Message negative>
                                { this.props.stripe.error.message }
                            </Message> }
                        { this.props.products.error &&
                            <Message negative>
                                { this.props.products.error.message }
                            </Message> }
                        <div style={{"flexShrink": "1", "flexDirection": "row"}}>
                            <CounterInput
                                count={1}
                                min={1}
                                max={10}
                                wrapperStyle={{"justifyContent": 'center'}}
                                onCountChange={count => 
                                    this.setState({quantity: count})}
                            />
                        </div>
                        <Button 
                            loading={this.props.products.loading}
                            type="submit"
                            primary
                            disabled={this.props.products.loading}
                            fluid
                            size="medium" 
                            onClick={() => this.payNow(selectedProduct.uuid, selectedProduct.price*this.state.quantity/100)}>
                            Pay Now ${selectedProduct.price*this.state.quantity/100}
                        </Button>
                    </div>
                </div>
            );
        }
        return(<div></div>)
    }

    payNow(uuid, price){
        if (this.props.stripe.customer && this.props.stripe.customer.sources && this.props.stripe.customer.sources.data && this.props.stripe.customer.sources.data.length == 0) {
            confirmAlert({
                title: 'Please add a payment card first',
                message: '',
                buttons: [
                {
                    label: 'Cancel',
                    onClick: () => {}
                },
                {
                    label: 'Manage My Wallet',
                    onClick: () => {
                        this.props.history.push('/app/profile?show=wallet');
                    }
                }
                ]
            });
            return;
        }

        confirmAlert({
            title: 'Proceed with payment?',
            message: 'You will be charged $'+price+' for this purchase.',
            buttons: [
            {
                label: 'Cancel',
                onClick: () => {}
            },
            {
                label: 'OK',
                onClick: () => {this._proceedBuy(uuid)}
            }
            ]
        });
    };

    _proceedBuy(uuid) {

        this.props.productsBuyAction(uuid, this.state.quantity).then(() => {

            const {error} = this.props.products;

            if (error) {
                if (error.message.startsWith("You don't have an active card")) {
                    confirmAlert({
                        title: 'Failed to make payment',
                        message: 'Please add a payment card before make a payment.',
                        buttons: [
                        {
                            label: 'Cancel',
                            onClick: () => {}
                        },
                        {
                            label: 'Manage My Wallet',
                            onClick: () => {
                                this.props.history.push('/app/profile?show=wallet');
                            }
                        }
                        ]
                    });
                    return;
                }
                return;
            }

            window.alert("Your payment is successful!");
            let path = `/app/store`;
            this.props.history.push(path);
        });
    }

    loadStripeCustomer() {
        this.props.getCustomerAction().then(() => {
            const {error} = this.props.stripe;

            if (error) {
                return;
            }
        })
    }

    checkStripeSession(successCallback) {
        if (this.props.stripe.ephemeral_key) {
            if (moment().unix() > this.props.stripe.ephemeral_key.expires) {
                this.props.getEphemeralKeyAction().then(() => {
                    const {error} = this.props.stripe;

                    if (error) {
                        return successCallback(false);
                    }

                    return successCallback(true);

                })
            } else {
                return successCallback(true);
            }
        } else {
            this.props.getEphemeralKeyAction().then(() => {
                const {error} = this.props.stripe;
                console.log("eph", this.props.stripe)
                if (error) {
                    return successCallback(false);
                }

                return successCallback(true);

            })
        }
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        products: state.products,
        stripe: state.stripe,
        contactNoVerified: state.otp.contactNoVerified
    }
}

export default connect(mapStateToProps, {
    productsBuyAction, getCustomerAction, getEphemeralKeyAction
})(ProductViewPage);